import styled from 'styled-components'
import { ClinTheme } from '../../ClinTheme'
import { mediaQueryDown } from '../../utils/mediaQuery'
import { ClinText } from '../../components/ClinText'
import { IClinTextProps } from '../../components/ClinText/ClinText'
import { ClinButton } from '../../components/ClinButton'

const mobileUpBreakpoint = ClinTheme.breakpoints[0]
const desktopUpBreakpoint = ClinTheme.breakpoints[2]

export const StyledButtonRow = styled.div({
  display: 'flex',
  justifyContent: 'center',
  gap: `${ClinTheme.space[4]}px`,
  flexWrap: 'wrap',
  width: '100%',

  [mediaQueryDown(mobileUpBreakpoint)]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: `${ClinTheme.space[3]}px`
  }
})

export const StyledNotFound = styled.div({
  backgroundColor: ClinTheme.colors.white,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  maxWidth: ClinTheme.containerWidths[3],
  alignItems: 'center',
  margin: '0 auto',
  boxSizing: `border-box`,
  marginTop: `${ClinTheme.space[6]}px`,

  [mediaQueryDown(desktopUpBreakpoint)]: {
    width: 'calc(100% - 40px)',
    maxWidth: 'calc(100% - 40px)'
  },

  [mediaQueryDown(mobileUpBreakpoint)]: {
    marginTop: '-24px'
  }
})

export const StyledNotFoundContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '640px',
  alignItems: 'center',
  margin: '0 auto',
  padding: `${ClinTheme.space[5]}px`,
  gap: `${ClinTheme.space[2]}px`,
  boxSizing: 'border-box'
})

export const StyledTitleRow = styled.div({
  display: 'flex',
  gap: `${ClinTheme.space[2]}px`
})

export const StyledTitle = styled(ClinText)<IClinTextProps>({
  fontSize: ClinTheme.fontSizes[4],
  lineHeight: ClinTheme.lineHeights.heading[1],
  fontWeight: ClinTheme.fontWeights.medium,
  margin: 0,
  whiteSpace: 'nowrap'
})

export const StyledTitleValue = styled(ClinText)<IClinTextProps>({
  fontSize: ClinTheme.fontSizes[4],
  lineHeight: ClinTheme.lineHeights.heading[1],
  fontWeight: ClinTheme.fontWeights.bold,
  margin: 0
})

export const StyledDescription = styled(ClinText)<IClinTextProps>({
  fontSize: ClinTheme.fontSizes[2],
  lineHeight: ClinTheme.lineHeights.body,
  textAlign: 'center',
  marginBottom: `${ClinTheme.space[3]}px`
})

export const StyledNotFoundButton = styled(ClinButton)({
  color: ClinTheme.colors.primary,

  ':hover': {
    color: ClinTheme.colors.white
  }
})
